import { c as _c } from "react/compiler-runtime";
import { useCallback, useLayoutEffect, useRef } from "react";
function snapViewportToLatest(viewport: HTMLDivElement | null) {
  if (!viewport) {
    return;
  }
  const maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  // Show the latest column fully, even when the viewport width is not aligned to a column stride.
  viewport.scrollLeft = maxScrollLeft;
}
export function useHeatmapViewport(resetKey) {
  const $ = _c(5);
  const viewportRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = node => {
      viewportRef.current = node;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setViewportRef = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      snapViewportToLatest(viewportRef.current);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== resetKey) {
    t2 = [resetKey];
    $[2] = resetKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      viewportRef: setViewportRef
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}